import { FormattedMessage } from 'components/shared/Intl';
import {
  ConnectedTradeWayLiteral,
  FlowWayLiteral,
  PriceNext,
  QuoteStatus,
  SolveResult,
  Spinner,
} from 'components/shared/PriceNext';
import type { PropsWithChildren } from 'react';

import { SolveModeLabel } from '../SolveMode';
import { connectTradePending, TradePendingState } from './trade.pending.connect';

export function Component({
  tabId,
  workspaceType,
  solvingMode,
  isMultipleSolvingMode,
  solveResult,
  solveResultFormat,
  priceInPercent = 0,
  priceInCurrency = 0,
  currency = '',
  flowWay,
}: PropsWithChildren<TradePendingState>) {
  return (
    <PriceNext
      className="sg-price bg-warning text-warning bg-opacity-10"
      tradeWay={<ConnectedTradeWayLiteral tabId={tabId} workspaceType={workspaceType} />}
      solveMode={
        <SolveModeLabel
          workspaceType={workspaceType}
          solvingMode={solvingMode}
          isMultipleSolvingMode={isMultipleSolvingMode}
        />
      }
      shareButton={
        <span className="badge badge-outline-warning badge-xl m-2 rounded-pill fw-bold">
          <FormattedMessage id="pleaseWait" />
        </span>
      }
      solveResult={<SolveResult className="me-2" price={solveResult} priceFormat={solveResultFormat} />}
      flowWay={
        <FlowWayLiteral
          flowWay={flowWay}
          priceInPercent={priceInPercent}
          priceInCurrency={priceInCurrency}
          currency={currency}
        />
      }
      quoteStatus={
        <QuoteStatus
          className="alert alert-warning"
          icon={Spinner}
          description="sidePanel.quoteStatus.tradeInProgress"
        />
      }
    />
  );
}

export const TradePendingComponent = connectTradePending(Component);

Component.displayName = 'TradePendingComponent';
